/* ==========================================================================
   Consentement Yumeka — Shopify Customer Privacy API.

   Le theme ne decide jamais du consentement : il le demande a Shopify et
   attend la reponse. Deux consequences qui expliquent la forme de ce fichier.

   1. Rien n'est stocke ici. Pas de localStorage, pas de cookie maison : l'etat
      vit dans le cookie de consentement de Shopify, seul endroit que les
      pixels Web (Meta, Google) consultent. Un miroir local ne servirait qu'a
      diverger, et un `_consent_ok` ecrit au chargement vaudrait acceptation
      automatique — exactement ce que le RGPD interdit.

   2. La carte ne se ferme qu'apres le rappel de Shopify. Fermer d'abord et
      enregistrer ensuite afficherait un site consenti alors que l'appel peut
      encore echouer.

   L'API arrive par loadFeatures : `window.Shopify.customerPrivacy` n'existe
   pas avant. Tout part de la.
   ========================================================================== */
(function () {
  'use strict';

  var racine = document.querySelector('[data-cookie-banner]');
  if (!racine) return;

  var carte    = racine.querySelector('[data-cookie-card]');
  var vueMain  = racine.querySelector('[data-cookie-main]');
  var vuePanel = racine.querySelector('[data-cookie-panel]');
  var focusAvant = null;

  function $$(sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }

  /* ---------- Ouverture, fermeture, focus -------------------------------- */

  var SELECTEUR_FOCUS = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return $$(SELECTEUR_FOCUS).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function ouvrir(vue) {
    focusAvant = document.activeElement;
    racine.hidden = false;
    montrer(vue || 'main', true);
    /* La page derriere ne doit pas defiler pendant que la carte est ouverte. */
    document.documentElement.style.overflow = 'hidden';
    /* Deux images successives : `hidden` retire puis la classe posee. Sans ce
       delai le navigateur applique les deux dans le meme calcul de style et la
       transition d'ouverture ne joue pas.

       Le focus part d'ici, et pas avant : tant que .is-open n'est pas posee, la
       carte est en `visibility: hidden`, et un element invisible ne prend pas
       le focus — l'appel etait purement decoratif, le clavier restait dans la
       page du dessous. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        racine.classList.add('is-open');
        carte.focus();
      });
    });
  }

  function fermer() {
    racine.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { racine.hidden = true; }, 200);
    /* Le focus revient d'ou il venait — le lien « Gerer mes cookies » quand la
       carte a ete rouverte depuis le pied de page. */
    if (focusAvant && typeof focusAvant.focus === 'function') focusAvant.focus();
    focusAvant = null;
  }

  function montrer(vue, pendantOuverture) {
    var versPanel = vue === 'panel';
    vueMain.hidden = versPanel;
    vuePanel.hidden = !versPanel;
    /* A l'ouverture, c'est ouvrir() qui pose le focus une fois la carte
       visible. Ici on ne le fait que pour un changement d'ecran, ou la carte
       est deja a l'ecran et ou le focus doit suivre la vue affichee. */
    if (pendantOuverture) return;
    var premier = focusables()[0];
    if (premier) premier.focus();
  }

  /* Piege a focus. La tabulation tourne dans la carte tant qu'elle est
     ouverte : sans cela le focus part dans la page masquee derriere l'overlay,
     ou plus rien n'est visible.

     Echap n'est pas ecoute : fermer sans choisir ne vaut pas refus, et faire
     de la touche un refus silencieux serait un choix pris a la place de la
     visiteuse. */
  racine.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var liste = focusables();
    if (!liste.length) return;
    var premier = liste[0];
    var dernier = liste[liste.length - 1];
    if (e.shiftKey && document.activeElement === premier) {
      e.preventDefault(); dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault(); premier.focus();
    }
  });

  /* Un clic sur l'overlay ne ferme pas : meme raison que la croix absente. */
  racine.addEventListener('mousedown', function (e) {
    if (!carte.contains(e.target)) e.preventDefault();
  });

  /* ---------- Enregistrement du consentement ----------------------------- */

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  /* `preferences` n'est accepte que par les versions recentes de l'API ; les
     plus anciennes ignorent la cle sans broncher. On l'envoie toujours, la
     categorie est reelle dans le panneau. */
  function enregistrer(choix, apres) {
    var cp = api();
    if (!cp) return;
    var boutons = $$('button');
    boutons.forEach(function (b) { b.disabled = true; });

    var termine = false;
    function fini(ok) {
      if (termine) return;
      termine = true;
      boutons.forEach(function (b) { b.disabled = false; });
      if (ok) { fermer(); if (typeof apres === 'function') apres(); }
    }

    try {
      cp.setTrackingConsent({
        analytics:   !!choix.analytics,
        marketing:   !!choix.marketing,
        preferences: !!choix.preferences
      }, function (res) {
        /* Shopify passe un objet portant `error` quand l'enregistrement a
           echoue. La carte reste alors ouverte : mieux vaut redemander que
           laisser croire a un choix enregistre. */
        fini(!(res && res.error));
      });
    } catch (e) {
      fini(false);
    }
  }

  var TOUT_OUI = { analytics: true,  marketing: true,  preferences: true  };
  var TOUT_NON = { analytics: false, marketing: false, preferences: false };

  function lireInterrupteurs() {
    var choix = { analytics: false, marketing: false, preferences: false };
    $$('[data-cookie-cat]').forEach(function (input) {
      choix[input.getAttribute('data-cookie-cat')] = input.checked;
    });
    return choix;
  }

  function poserInterrupteurs(choix) {
    $$('[data-cookie-cat]').forEach(function (input) {
      input.checked = !!choix[input.getAttribute('data-cookie-cat')];
    });
  }

  /* ---------- Branchements ---------------------------------------------- */

  racine.addEventListener('click', function (e) {
    var cible = e.target.closest ? e.target.closest('button') : null;
    if (!cible) return;

    if (cible.hasAttribute('data-cookie-accept')) {
      poserInterrupteurs(TOUT_OUI);
      enregistrer(TOUT_OUI);
    } else if (cible.hasAttribute('data-cookie-refuse')) {
      poserInterrupteurs(TOUT_NON);
      enregistrer(TOUT_NON);
    } else if (cible.hasAttribute('data-cookie-save')) {
      enregistrer(lireInterrupteurs());
    } else if (cible.hasAttribute('data-cookie-settings')) {
      montrer('panel');
    } else if (cible.hasAttribute('data-cookie-back')) {
      montrer('main');
    }
  });

  /* Rouverture depuis le pied de page. Le lien porte l'etat deja enregistre
     dans ses interrupteurs, pour que la visiteuse modifie un choix au lieu de
     le reprendre a zero. */
  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('[data-cookie-open]') : null;
    if (!lien) return;
    e.preventDefault();
    var cp = api();
    if (cp) {
      var etat = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      poserInterrupteurs({
        analytics:   etat.analytics   === 'yes' || etat.analytics   === true,
        marketing:   etat.marketing   === 'yes' || etat.marketing   === true,
        preferences: etat.preferences === 'yes' || etat.preferences === true
      });
    }
    ouvrir('panel');
  });

  /* ---------- Demarrage -------------------------------------------------- */

  function demarrer() {
    var cp = api();
    if (!cp) return;
    /* Deux conditions, et non une seule.

       `shouldShowBanner()` repond a « ce visiteur est-il dans une region ou le
       consentement se demande ? ». On l'a d'abord pris pour « faut-il afficher
       le bandeau ? » : c'est faux. Observe en France, il reste a true APRES un
       refus — la region continue d'exiger le consentement, que la visiteuse
       ait tranche ou non. Le bandeau revenait donc a chaque chargement, et
       redemandait un choix deja donne.

       La decision enregistree se lit sur `currentVisitorConsent()`, dont
       chaque champ vaut 'yes', 'no', ou '' tant que rien n'a ete choisi. Les
       trois champs renseignes valent decision prise, quel qu'en soit le sens.

       Cette condition ne gouverne que l'ouverture automatique : « Gerer mes
       cookies » appelle ouvrir() directement et reste donc disponible en
       permanence, y compris apres un refus. */
    try {
      var consent = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      var decisionEnregistree = [
        consent.analytics,
        consent.marketing,
        consent.preferences
      ].every(function (valeur) { return valeur === 'yes' || valeur === 'no'; });

      if (cp.shouldShowBanner() && !decisionEnregistree) ouvrir('main');
    } catch (e) { /* API indisponible : aucun bandeau plutot qu'un bandeau casse */ }
  }

  function charger() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (erreur) { if (!erreur) demarrer(); }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', charger);
  } else {
    charger();
  }
})();
